module.exports = __webpack_public_path__ + "media/src/assets/Images/Building-2a4415131573e37a8f9bee856c3c9d00.svg";